function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const IntercomIcon = _ref => {
  let {
    size = 16,
    bg = '#F1617D',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M0 0h300v300H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFF",
    d: "M138.5 252.3c10.5 7 27.1 11.4 43.7 11.4 30.6 0 53.3-13.3 53.3-42.8 0-25.3-14.1-37.4-46.3-44.3-16.3-4.4-22.4-9.2-22.4-18.4s7.4-15.8 21.1-15.8c15 0 27.1 5.4 39.6 14.2v-28.8c-11.8-7.3-24.6-10.8-40.6-10.8-28.7 0-50.4 13.9-50.4 42.4 0 24.4 12.4 36.1 41.8 42.8 18.2 4.8 26.5 8.9 26.5 20.3 0 11.1-9.3 15.8-23.3 15.8-14.4 0-30-6-43.1-15.8l.1 29.8zm-6.1-105.8h-14.7v114H86.5v-114h-22v-26.3h22V93.9c0-34.8 19.2-51.9 48.8-51.9 11.2 0 19.8 2.2 27.8 7v28.8c-7.7-5.1-14.7-7.9-24.3-7.9-13.4 0-21.1 6.7-21.1 23.8v26.6H152c-10.3 5.1-17.5 14.9-19.6 26.2z"
  }));
};
export default IntercomIcon;